import { Pressable, Text, View } from 'react-native';
import styled from 'styled-components/native';
import { mixins } from '~/theme';

export const Container = styled(View)`
    width: 100%;
    background-color: ${({ theme }) => theme.fill.level2};
    border-radius: 12px;
    overflow: hidden;
`;

export const Button = styled(Pressable)`
    flex-direction: row;
    width: 100%;
    padding: 16px;
    justify-content: space-between;
`;

export const Label = styled(Text)`
    ${mixins.typography.ui.regular12};
    color: ${({ theme }) => theme.text.tertiary};
`;

export const Title = styled(Text)`
    ${mixins.typography.ui.regular16};
    color: ${({ theme }) => theme.text.primary};
`;

export const Content = styled(View)``;

export const IconWrapper = styled(View)`
    justify-content: center;
    margin-left: 8px;
`;
